import React, { Fragment } from "react";

import banner11 from "../../assets/images/banner11.png";
import { CircleCardsSection } from "../../components/CircleCardsSection";
import { ConsultationBanner } from "../../components/ConsultationBanner/ConsultationBanner";
import { HeroSection } from "../../components/HeroSection";
import { TariffSection } from "../../components/TariffSection/TariffSection";
import { WorkflowSectionCustom } from "../../components/WorkflowSectionCustom/WorkflowSectionCustom";
import { workflowData } from "../../config/workflowData";
import { usePageData } from "../../hooks/usePageData";
import {
  Section,
  SmallTitle,
  TitleH2,
} from "../../styles/sharedStyles";

import {
  CLevelThemeScope,
  Container,
  WorkflowSection,
} from "./styles"

const workflow = workflowData.c_level__page

const C_LEVEL_CARD_ACCENTS = ["#AEB9FF", "#EBC6FF", "#FFF9B1"] as const;

const C_LEVEL_AUDIENCE_CARDS = [
  "Хотите выйти на новый уровень",
  "В поиске более сильных, интересных предложений",
  "Хотите сменить рынок / масштаб / роль",
  "Важно позиционирование, а не массовый отклик",
];

const C_LEVEL_APPROACH_CARDS = [
  "Конфиденциальность",
  "Ограниченное количество клиентов",
  "Индивидуальная работа",
  "Фокус на карьере, а не быстром результате",
];

export const CLevel = () => {
  const { card } = usePageData(8);
  const filteredProducts = card.filter(
    (item) => item.product_category.id === 19
  );
  const getAccentColor = (index: number) =>
    C_LEVEL_CARD_ACCENTS[index] || C_LEVEL_CARD_ACCENTS[0];

  return (
    <CLevelThemeScope>
      <Fragment>
        <HeroSection />
        <Section>
          <Container>
            <SmallTitle>мы помогаем</SmallTitle>
            <TitleH2>Топ-менеджерам, руководителям</TitleH2>
            <CircleCardsSection
              cards={C_LEVEL_AUDIENCE_CARDS}
              activeCardIndex={0}
              ariaLabel="Для кого подходит продвижение C-level"
              stackDirection="leftOnTop"
            />
          </Container>
        </Section>
        <WorkflowSection>
          <Container>
            <TitleH2>Как проходит работа</TitleH2>
            <WorkflowSectionCustom data={workflow} />
          </Container>
        </WorkflowSection>
        <Section>
          <Container>
            <SmallTitle>тарифы</SmallTitle>
            <TitleH2>Как мы можем помочь</TitleH2>
            <TariffSection
              products={filteredProducts}
              color="#BCD3FF"
              getAccentColor={getAccentColor}
            />
          </Container>
        </Section>
        <Section>
          <Container>
            <SmallTitle>наш подход</SmallTitle>
            <TitleH2>Мы внимательно работаем над каждым кейсом</TitleH2>
            <CircleCardsSection
              cards={C_LEVEL_APPROACH_CARDS}
              activeCardIndex={3}
              ariaLabel="Подход к продвижению C-level"
              stackDirection="leftOnTop"
            />
          </Container>
        </Section>
        <ConsultationBanner backgroundImage={banner11}/>
      </Fragment>
    </CLevelThemeScope>
  )
}
